import { render, staticRenderFns } from "./ChangeAugrNameDialog.vue?vue&type=template&id=fbdcb180&scoped=true"
import script from "./ChangeAugrNameDialog.vue?vue&type=script&lang=js"
export * from "./ChangeAugrNameDialog.vue?vue&type=script&lang=js"
import style0 from "./ChangeAugrNameDialog.vue?vue&type=style&index=0&id=fbdcb180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdcb180",
  null
  
)

export default component.exports